import { useDeleteSession } from "@/api/auth/queries";
import { AuthLoader } from "@/features/auth/components/auth-loader";
import ENV from "@/utils/env";
import { useEffect } from "react";

/**
 * buildAuth0LogoutUrl function
 *
 * Builds the Auth0 logout URL.
 *
 * @returns The full Auth0 logout URL.
 */
export const buildAuth0LogoutUrl = () => {
  const params = new URLSearchParams({
    client_id: ENV.AUTH0_CLIENT_ID,
    returnTo: ENV.AUTH0_LOGOUT_URL,
  });

  return `${ENV.AUTH0_DOMAIN}/v2/logout?${params.toString()}`;
};

/*
 * SignoutRoute component
 *
 * Deletes the session and then redirects to the Auth0 signout endpoint.
 */
export const SignoutRoute = () => {
  /* Hooks */
  const { mutate: deleteSession } = useDeleteSession();

  /* Side Effects */
  useEffect(() => {
    // Delete session first, then redirect
    deleteSession(undefined, {
      onSuccess: () => {
        // Redirect to Auth0 for logout
        // This will clear the Auth0 session and then redirect back to our app.
        window.location.replace(buildAuth0LogoutUrl());
      },
    });
  }, [deleteSession]);

  return <AuthLoader loaderText="Signing out..." />;
};
